module.exports = __webpack_public_path__ + "img/mysql.e1ebd9e5.svg";